import { render, staticRenderFns } from "./subjects-add.vue?vue&type=template&id=385a331a&scoped=true&"
import script from "./subjects-add.vue?vue&type=script&lang=js&"
export * from "./subjects-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a331a",
  null
  
)

export default component.exports